// DataPegawai.js
import React, { useEffect, useState, useMemo, useCallback } from "react";
import { Row, Col, Form, Spinner, Button, Modal } from "react-bootstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import DataTable from "react-data-table-component";

import PegawaiService from "../../services/registrasi/PegawaiService";
import Card from "../../components/Card";

const DataPegawai = () => {
  const [namaUPT,] = useState(null);
  const [showSendSuccess, setShowSendSucces] = useState(false);
  const [showSendFailed, setShowSendFailed] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [Pegawai, setPegawai] = useState([]);
  const [loading, setLoading] = useState(true);
  const [size, setSize] = useState(10);
  const [page, setPage] = useState(0);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedNip, setSelectedNip] = useState(null);
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);
  const [showDeleteSuccess, setShowDeleteSuccess] = useState(false);
  const [listUPT, setListUPT] = useState([]);
  const [roles, setRoles] = useState([]);


  const role = localStorage.getItem("role");
  const [kdUPT] = useState(localStorage.getItem("kdUnit"));
  
  const userService = useMemo(() => new PegawaiService(), []);

  const [formData, setFormData] = useState({
  NIP: "",
  NAMA: "",
  JABATAN: "",
  UNIT: namaUPT,
  KD_UNIT: kdUPT,
  STATUS: "",
  NO_REG: "",
  ROLE: "",
  ALAMAT: "",    
  EMAIL: "" ,     
  });

const handleEdit = useCallback(async (row) => {
  try {
    const res = await userService.getDataPegawaiByNIP(row.NIP);
    const data = res.data;

    setFormData({
      NIP: data.NIP || "",
      NAMA: data.NAMA || "",
      JABATAN: data.JABATAN || "",
      UNIT: data.UNIT || "",
      KD_UNIT: data.KD_UNIT || "",
      STATUS: data.STATUS || "",
      NO_REG: data.NO_REG || "",
      ROLE: data.userData?.ROLE || "",
      EMAIL: data.userData?.EMAIL|| "",
    }, );

    setShowModal(true);
    setIsEditMode(true);
  } catch (error) {
    console.error("Gagal ambil data pegawai untuk edit:", error);
    alert("Gagal mengambil data pegawai");
  }
},[userService]);

const handleDelete = useCallback((nip) => {
  setSelectedNip(nip);
  setShowConfirmDelete(true);
}, []);

  const columns = useMemo(() => [
    { name: "NIP", selector: row => row.NIP, width: "200px",  center: true },
    { name: "Nama", selector: row => row.NAMA, width: "300px",  center: true },
    { name: "Jabatan", selector: row => row.JABATAN, width: "250px",  center: true,   
      cell: row => (
      <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', textAlign: 'center' }}>
      {row.JABATAN}
    </div>
    ) },
    { name: "Unit Kerja", selector: row => row.UNIT, width: "250px",  center: true,
      cell: row => (
      <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', textAlign: 'center' }}>
      {row.UNIT}
    </div>
    )},
    { name: "No Reg Inspektur", selector: row => row.NO_REG, width: "150px", center: true },
    { name: "Email", selector: row => row.userData?.EMAIL, width: "200px", center: true },
    {
      name: "Aksi",
      cell: (row) => (
        <>
          {["1", "2"].includes(role) && (
            <>
              <Button variant="warning" size="sm" className="me-2" onClick={() => handleEdit(row)}>Edit</Button>{" "}
              <Button variant="danger" size="sm" onClick={() => handleDelete(row.NIP)}>Hapus</Button>{" "}
            </>
          )}
          {/* <Button variant="primary" size="sm" onClick={() => handleView(row)}>View</Button> */}
        </>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: "210px",
      align: "center",
      center: true,
    },
  ], [role, handleEdit, handleDelete]);

  const filteredData = useMemo(() => {
    const keyword = searchKeyword.toLowerCase();
    return Pegawai.filter((p) => {
      const allowByRole = ["1"].includes(role);
      const allowByKdUnit = p.KD_UNIT === kdUPT;
      const keywordMatch =
        (p.NIP || "").toLowerCase().includes(keyword) ||
        (p.NAMA || "").toLowerCase().includes(keyword) ||
        (p.JABATAN || "").toLowerCase().includes(keyword) ||
        (p.UNIT || "").toLowerCase().includes(keyword) ||
        (p.NO_REG || "").toLowerCase().includes(keyword)||
        (p.EMAIL || "").toLowerCase().includes(keyword);

      return keywordMatch && (allowByRole || allowByKdUnit);
    });
  }, [Pegawai, searchKeyword, role, kdUPT]);

  const paginatedData = useMemo(() => {
    const start = page * size;
    return filteredData.slice(start, start + size);
  }, [filteredData, page, size]);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const res = await userService.getAllDataPegawai();
      setPegawai(res.data);
    } catch (error) {
      console.error("Gagal ambil data pegawai", error);
    } finally {
      setLoading(false);
    }
  }, [userService]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    if (showModal && namaUPT) {
      setFormData((prev) => ({ ...prev, UNIT: namaUPT }));
    }
  }, [namaUPT, showModal]);

  useEffect(() => {
  const fetchUPT = async () => {
    try {
      const res = await userService.getAllUPT();
      // console.log("DATA UPT:", res.data); 

      if (Array.isArray(res.data)) {
        setListUPT(res.data);
      } else if (Array.isArray(res.data.data)) {
        setListUPT(res.data.data); 
      } else {
        console.warn("Data UPT bukan array:", res.data);
        setListUPT([]);
      }
    } catch (err) {
      console.error("Gagal ambil data UPT", err);
      setListUPT([]);
    }
  };

  fetchUPT();
}, [userService]);

useEffect(() => {
  const fetchRoles = async () => {
    try {
      const res = await userService.getAllRole();
      setRoles(res.data);
    } catch (err) {
      console.error("Gagal ambil role", err);
      setRoles([]);
    }
  };
  fetchRoles();
}, [userService]);

  const handleAdd = () => {
    setFormData({
      NIP: "",
      NAMA: "",
      JABATAN: "",
      UNIT: namaUPT,
      KD_UNIT: kdUPT,
      STATUS: "",
      NO_REG: "",
      ROLE: "",
      EMAIL:"",
    });
    setShowModal(true);
    setIsEditMode(false);
  };

  const handleSubmit = async () => {
  // console.log("Data yang dikirim:", formData);
  if (!["1", "2"].includes(role)) {
    alert("Anda tidak memiliki akses untuk menyimpan data.");
    return;
  }

  if (!formData.NIP || !formData.NAMA) {
    setShowSendFailed(true);
    return;
  }

  setIsLoading(true);

  try {
    if (isEditMode) {

      const res = await userService.updateDataPegawai(formData.NIP, formData);
      console.log("Berhasil update:", res);
    } else {

      const res = await userService.addDataPegawai(formData);
      console.log("Berhasil tambah:", res);
    }

  
    const pegawaiBaru = await userService.getAllDataPegawai();
    setPegawai(pegawaiBaru.data);

    setShowModal(false);
    setShowSendSucces(true);
  } catch (err) {
    console.error("Gagal simpan data:", err);
    setShowSendFailed(true);
  } finally {
    setIsLoading(false);
  }
};
const confirmDelete = async () => {
  try {
    await userService.deleteDataPegawai(selectedNip);
    const res = await userService.getAllDataPegawai();
    setPegawai(res.data);
    setShowConfirmDelete(false);
    setShowDeleteSuccess(true); 
  } catch (err) {
    console.error("Gagal hapus data", err);
    alert("Gagal menghapus data");
    setShowConfirmDelete(false);
  }
};

const cancelDelete = () => {
  setShowConfirmDelete(false);
  setSelectedNip(null);
};


  return (
    <Row>
      <Col sm="12">
        {/* Pencarian dan Tambah Data */}
        <Card>
          <Card.Header className="d-flex justify-content-between">
            <div className="header-title">
              <h4 className="card-title">Pencarian Data</h4>
            </div>
          </Card.Header>
          <Card.Body>
            <Form>
              <Row className="align-items-end">
                <Col sm="3">
                  <Form.Group>
                    <Form.Control
                      type="text"
                      placeholder="Cari disini..."
                      value={searchKeyword}
                      onChange={(e) => setSearchKeyword(e.target.value)}
                    />
                  </Form.Group>
                </Col>
                <Col sm="2">
                  <Button variant="secondary" className="w-100" onClick={() => setSearchKeyword("")}>Reset</Button>
                </Col>
              </Row>
              <Row className="mt-2">
                {["1", "2"].includes(role) && (
                  <Col>
                    <Button variant="primary" onClick={handleAdd}>+Tambah Pegawai</Button>
                  </Col>
                )}
              </Row>
            </Form>
          </Card.Body>
        </Card>

        {/* Modal Tambah/Edit */}
        <Modal show={showModal} onHide={() => setShowModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Tambah Pegawai</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              {["NIP", "NAMA", "JABATAN", "NO_REG", "EMAIL"].map((field) => (
                <Form.Group key={field} className="mb-1">
                  <Form.Label>{field}</Form.Label>
                  <Form.Control
                      type="text"
                      name={field}
                      value={formData[field] || ""}
                      onChange={(e) => {
                        const { name, value } = e.target;
                        if (name === "NIP" && !/^\d*$/.test(value)) return; 
                        setFormData((prevData) => ({ ...prevData, [name]: value }));
                      }}
                      />
                </Form.Group>
              ))}
              {role === "1" && (
                <Form.Group className="mb-3">
                  <Form.Label>Unit Kerja</Form.Label>
                  <Form.Select
                    value={formData.KD_UNIT}
                    onChange={(e) => {
                      const selected = listUPT.find(u => u.KD_UNIT === e.target.value);
                      setFormData({
                        ...formData,
                        KD_UNIT: selected?.KD_UNIT || "",
                        UNIT: selected?.NM_UNIT || "",
                      });
                    }}
                  >
                    <option value="">-- Pilih UPT --</option>
                    {listUPT.map((upt) => (
                      <option key={upt.KD_UNIT} value={upt.KD_UNIT}>
                        {upt.NM_PENDEK}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              )}
                <Form.Group className="mb-3">
                <Form.Label>Role</Form.Label>
                  <Form.Select
                    value={formData.ROLE}
                    onChange={(e) => setFormData({ ...formData, ROLE: e.target.value })}
                  >
                    <option value="">-- Pilih Role --</option>
                    {roles.map((r) => {
                      
                      if (role === "1" && (r.id === 6 || r.id === 2)) {
                        return (
                          <option key={r.id} value={r.id}>
                            {r.role_user}
                          </option>
                        );
                      }

                      if (r.id === 3 || r.id === 7 || r.id === 8 || r.id === 9) {
                        return (
                          <option key={r.id} value={r.id}>
                            {r.role_user}
                          </option>
                        );
                      }

                      return null;
                    })}
                  </Form.Select>
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowModal(false)}>Batal</Button>
            <Button type="button" onClick={handleSubmit} disabled={isLoading}>
              {isLoading ? "Menyimpan..." : "Submit"}
            </Button>
          </Modal.Footer>
        </Modal>

        {showSendSuccess && (
          <SweetAlert success title="Kirim Data Berhasil" onConfirm={() => setShowSendSucces(false)} btnSize="sm" />
        )}
        {showSendFailed && (
          <SweetAlert danger title="Kirim Data Gagal" onConfirm={() => setShowSendFailed(false)} btnSize="sm" timeout={4000} />
        )}

        {showConfirmDelete && (
            <SweetAlert
              warning
              showCancel
              confirmBtnText="Ya, hapus"
              cancelBtnText="Batal"
              confirmBtnBsStyle="danger"
              cancelBtnBsStyle="default"
              title={`Yakin ingin menghapus data NIP ${selectedNip}?`}
              onConfirm={confirmDelete}
              onCancel={cancelDelete}
              focusCancelBtn
            >
              Data pegawai akan dihapus permanen dari sistem.
            </SweetAlert>
          )}
          {showDeleteSuccess && (
            <SweetAlert
              success
              title="Berhasil Dihapus"
              onConfirm={() => setShowDeleteSuccess(false)}
              btnSize="sm"
            >
              Data pegawai berhasil dihapus dari sistem.
            </SweetAlert>
          )}

        <Card>
          <Card.Header className="d-flex justify-content-between">
            <div className="header-title">
              <h4 className="card-title">Daftar Pegawai Unit Pelaksana Teknis</h4>
            </div>
          </Card.Header>
          <Card.Body>
            <div className="table-responsive border-bottom my-3">
              {loading ? (
                <Spinner animation="border" />
              ) : (
                <DataTable
                  columns={columns}
                  data={paginatedData}
                  highlightOnHover
                  pagination
                  paginationServer
                  paginationPerPage={size}
                  paginationTotalRows={filteredData.length}
                  onChangePage={(newPage) => setPage(newPage - 1)}
                  onChangeRowsPerPage={(newSize) => { setSize(newSize); setPage(0); }}
                  persistTableHead
                  customStyles={{
                        headCells: {
                          style: {
                            backgroundColor: "#00acee",
                            color: "white",
                          },
                        },
                        cells: {
                          style: {
                            whiteSpace: 'normal',
                            wordWrap: 'break-word',
                            fontSize: '14px',
                          },
                        },
                        rows: {
                          style: {
                            minHeight: '60px',
                          },
                        },
                      }}
                    />
              )}
            </div>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};
export default DataPegawai;
